var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-full",style:(_vm.containerStyle)},[_c('div',{staticClass:"absolute inset-0 w-full h-full"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }